import Vue from 'vue'
import Router from 'vue-router'
import i18n from '@/helpers/i18n';

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Login = () => import('@/views/Login')
const PrivacyPolicy = () => import('@/views/PrivacyPolicy')
const Page404 = () => import('@/views/Page404');

// Views - Pages
const CategoriesList = () => import('@/views/Categories/CategoriesList')
const CategoryAdd = () => import('@/views/Categories/CategoryAdd')
const CategoryEdit = () => import('@/views/Categories/CategoryEdit')
const OrdersList = () => import('@/views/Orders/OrdersList')
const PalettesList = () => import('@/views/Palettes/PalettesList')
const PaletteAdd = () => import('@/views/Palettes/PaletteAdd')
const PaletteEdit = () => import('@/views/Palettes/PaletteEdit')
const PostsList = () => import('@/views/Posts/PostsList')
const PostAdd = () => import('@/views/Posts/PostAdd')
const PostEdit = () => import('@/views/Posts/PostEdit')
const ProductsList = () => import('@/views/Products/ProductsList')
const ProductAdd = () => import('@/views/Products/ProductAdd')
const ProductEdit = () => import('@/views/Products/ProductEdit')
const StaticInfosList = () => import('@/views/StaticInfos/StaticInfosList')
const StaticInfoAdd = () => import('@/views/StaticInfos/StaticInfoAdd')
const StaticInfoEdit = () => import('@/views/StaticInfos/StaticInfoEdit')
const UsersList = () => import('@/views/Users/UsersList')
const KeyValuesList = () => import('@/views/KeyValues/KeyValuesList')
const KeyValueAdd = () => import('@/views/KeyValues/KeyValueAdd')
const KeyValueEdit = () => import('@/views/KeyValues/KeyValueEdit')
const BannersList = () => import('@/views/Banners/BannersList')
const BannerAdd = () => import('@/views/Banners/BannerAdd')
const BannerEdit = () => import('@/views/Banners/BannerEdit')

Vue.use(Router)

export default new Router({
  mode: 'history', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes () {
  return [
    {
      path: '/',
      redirect: `/${i18n.locale}/encomendas`,
      name: 'Home',
      component: TheContainer,
      children: [
      {
        path: `/:lang/categorias`,
        redirect: `/${i18n.locale}/categorias/lista`,
        name: 'Categories',
        component: {
          render (c) { return c('router-view') }
        },
        children: [
            {
              path: `lista`,
              name: 'CategoriesList',
              component: CategoriesList
            },
            {
              path: `adicionar`,
              name: 'CategoryAdd',
              component: CategoryAdd
            },
            {
              path: `editar`,
              name: 'CategoryEdit',
              component: CategoryEdit
            },
          ]
        },
        {
          path: `/:lang/encomendas`,
          redirect: `/${i18n.locale}/encomendas/lista`,
          name: 'Orders',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: `lista`,
              name: 'OrdersList',
              component: OrdersList
            },
          ]
        },
        {
          path: `/:lang/paletas`,
          redirect: `/${i18n.locale}/paletas/lista`,
          name: 'Palettes',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: `lista`,
              name: 'PalettesList',
              component: PalettesList
            },
            {
              path: `adicionar`,
              name: 'PaletteAdd',
              component: PaletteAdd
            },
            {
              path: `editar`,
              name: 'PaletteEdit',
              component: PaletteEdit
            },
          ]
        },
        {
          path: `/:lang/publicacoes`,
          redirect: `/${i18n.locale}/publicacoes/lista`,
          name: 'Posts',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: `lista`,
              name: 'PostsList',
              component: PostsList
            },
            {
              path: `adicionar`,
              name: 'PostAdd',
              component: PostAdd
            },
            {
              path: `editar`,
              name: 'PostEdit',
              component: PostEdit
            },
          ]
        },
        {
          path: `/:lang/produtos`,
          redirect: `/${i18n.locale}/produtos/lista`,
          name: 'Products',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: `lista`,
              name: 'ProductsList',
              component: ProductsList
            },
            {
              path: `adicionar`,
              name: 'ProductAdd',
              component: ProductAdd
            },
            {
              path: `editar`,
              name: 'ProductEdit',
              component: ProductEdit
            },
          ]
        },
        {
          path: `/:lang/infos`,
          redirect: `/${i18n.locale}/infos/lista`,
          name: 'StaticInfos',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: `lista`,
              name: 'StaticInfosList',
              component: StaticInfosList
            },
            {
              path: `adicionar`,
              name: 'StaticInfoAdd',
              component: StaticInfoAdd
            },
            {
              path: `editar`,
              name: 'StaticInfoEdit',
              component: StaticInfoEdit
            },
          ]
        },
        {
          path: `/:lang/utilizadores`,
          redirect: `/${i18n.locale}/utilizadores/lista`,
          name: 'Users',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: `lista`,
              name: 'UsersList',
              component: UsersList
            },
          ]
        },
        {
          path: `/:lang/valores-chave`,
          redirect: `/${i18n.locale}/valores-chave/lista`,
          name: 'KeyValues',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: `lista`,
              name: 'KeyValuesList',
              component: KeyValuesList
            },
            {
              path: `adicionar`,
              name: 'KeyValueAdd',
              component: KeyValueAdd
            },
            {
              path: `editar`,
              name: 'KeyValueEdit',
              component: KeyValueEdit
            },
          ]
        },
        {
          path: `/:lang/banners`,
          redirect: `/${i18n.locale}/banners/lista`,
          name: 'Banners',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: `lista`,
              name: 'BannersList',
              component: BannersList
            },
            {
              path: `adicionar`,
              name: 'BannerAdd',
              component: BannerAdd
            },
            {
              path: `editar`,
              name: 'BannerEdit',
              component: BannerEdit
            },
          ]
        },
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/privacypolicy',
      name: 'PrivacyPolicy',
      component: PrivacyPolicy
    },
    {
      path: "*",
      name: '404',
      component: Page404
    },    
  ]
}

